import {Navigate} from "react-router-dom";
import { LOGIN} from "./RouteLinks";
import { useSelector} from "react-redux";

export const ProtectedRoute = ( { children } ) => {
    const { isLogin } = useSelector(state => state?.auth);

    if ( isLogin === false ) return <Navigate to={LOGIN} />;
    return children;
};